
import { defineComponent, ref, watch } from 'vue'
import DnbMapDetail from '@/components/DnbMapDetail.vue'
import DnbChip from './DnbChip.vue'

//eslint-disable-next-line
declare const kakao: any
const LATITUDE = 37.4012850380545// 위도
const LONGITUDE = 127.11045570879// 경도

export default defineComponent({
  components: {
    DnbChip,
    DnbMapDetail,
  },

  props: {
    platform: {
      type: String,
      default: 'desktop',
    },
  },

  setup (props) {
    const mapContainer = ref<HTMLElement | null>(null)
    const isOpenModal = ref(false)
    let map: {setCenter: (latLng: {La: number, Ma: number}) => void}
    const position = new kakao.maps.LatLng(LATITUDE, LONGITUDE)

    const initKakaoMap = (container: HTMLElement) => {
      const options = { center: position, level: 3 }
      map = new kakao.maps.Map(container, options)
      new kakao.maps.Marker({ map, position })
      map.setCenter(position)
    }

    const onMapClick = () => {
      isOpenModal.value = true
    }

    watch(() => mapContainer.value, (container) => {
      if (container) {
        initKakaoMap(container)
      }
    })

    return {
      mapContainer,
      onMapClick,
      isOpenModal,
    }
  },
})
